// extracted by mini-css-extract-plugin
export default {"blurredBackground":"GlobalWrapper_blurredBackground__FBUuz","backgroundOverride":"GlobalWrapper_backgroundOverride__wU7z3"};